module.exports = __webpack_public_path__ + "img/visit.673d0a70.svg";